import Image from "next/image";

export default function FreeZoneHero({
  badge,
  title,
  highlight,
  subtitle,
  cta1,
  cta2,
  image = "/FZ.webp"
}) {
  return (
    <section className="relative w-full min-h-screen py-20 flex items-center px-4 sm:px-6 lg:px-8 bg-[#FAFAFA] overflow-hidden">
          {/* subtle background effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#B8893A]/10 blur-[120px] rounded-full pointer-events-none" />
    
          {/* mobile background image + overlay */}
          <div className="absolute inset-0 block md:hidden">
            <Image
              src="/free-zone-mobile.webp"
              alt="Free Zone Business Setup"
              fill
              className="object-cover"
              priority
            />
            <div className="absolute inset-0 bg-black/55" />
          </div>
    
          <div className="relative z-10 w-full mx-auto max-w-[1280px] lg:max-w-[1440px] xl:max-w-[1600px] 2xl:max-w-[1800px] grid md:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 px-0">
            <div className="flex flex-col justify-center text-left md:text-left min-h-[60vh]">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#B8893A] border border-[#B8893A]/20 text-[#ffffff] text-[11px] sm:text-xs font-bold mb-5 sm:mb-6 max-w-max self-start">
                <span className="w-1.5 h-1.5 rounded-full bg-[#fafafa]" />
                Freezone Company Setup
              </div>
    
              <h1
                className="font-bold tracking-tight mb-6 sm:mb-8 text-white md:text-[#000000]"
                style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: "700", lineHeight: "1.3" }}
              >
                Get Your Free Zone {" "}
                <span className="relative inline-block text-white md:text-[#000000]">
                  Company Setup
                </span>
              </h1>
    
              <p
                className="text-white max-w-2xl mb-8 sm:mb-10 mx-auto md:mx-0 md:text-black"
                style={{ fontSize: "clamp(14px, 1.2vw, 16px)", lineHeight: "1.6" }}
              >
                With over 50 free zones in the UAE, how do you know which one is best for you? AWS Businessmen walks you through it step-by-step saving you money and making the entire experience stress-free.


              </p>
    
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center md:justify-start pt-4">
                <a
                  href="/contact"
                  className="px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4 bg-[#B8893A] hover:bg-[#A67B34] text-white font-semibold lg:font-bold rounded-xl transition-all duration-300 shadow-md hover:shadow-lg active:scale-[0.98] text-center text-sm sm:text-base"
                >
                  Get Started
                </a>
    
                <a
                  href="/calculator"
                  className="px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4 border border-gray-300 text-white md:text-black font-semibold rounded-xl hover:bg-gray-50 transition-all duration-300 active:scale-[0.98] text-center text-sm sm:text-base"
                >
                  Calculate Your Cost
                </a>
              </div>
            </div>
    
            <div className="hidden md:block relative w-full h-full min-h-[300px]">
              <div className="relative w-full h-[300px] sm:h-[400px] lg:h-[500px] xl:h-[550px] 2xl:h-[600px] overflow-hidden shadow-xl rounded-2xl">
                <Image
                  src="/freezone-hero.jpg"
                  alt="Mainland Business Setup"
                  fill
                  className="object-cover"
                  priority
                />
              </div>
            </div>
          </div>
        </section>
  );
}
